module.exports = __webpack_public_path__ + "static/media/vote-for-marina-valmont-in-maximsfinest-94bcaa84_thumbnail.847e148b.png";